// Las cuentas de "¿Quién atiende las citas de este enlace?" (Mi Booking Link),
// sin React para poder probarlas. La pantalla está en
// components/EquipoDelEnlace.jsx; el servidor decide con
// deskte-api/src/utils/equipoDelEnlace.ts.

export const TODAS = "todas";

/** Las personas encendidas en una fila; vacía = solo la dueña del enlace. */
export function personasEncendidas(equipo, clave, duena) {
  const l = (equipo && Array.isArray(equipo[clave])) ? equipo[clave] : [];
  return l.length ? l : [duena];
}

/** Enciende o apaga a una persona en una fila. Devuelve el equipo nuevo. */
export function alternarPersona(equipo, clave, id, duena) {
  const ahora = personasEncendidas(equipo, clave, duena);
  const nueva = ahora.includes(id) ? ahora.filter((x) => x !== id) : [...ahora, id];
  // Volver a "solo la dueña" se guarda vacío: es lo mismo y así se ve igual
  // que un enlace que nunca tocó esto.
  const lista = nueva.length === 1 && nueva[0] === duena ? [] : nueva;
  return { ...(equipo || {}), [clave]: lista };
}


// HORARIO PROPIO (Lissette 2026-10-17). Vive en `availability.horarios`:
// { <userId>: { mon: {active,start,end}, … } }. Sin horario propio, la persona
// usa el del enlace. El servidor lo recorta con el del enlace
// (horarioDePersona en deskte-api/src/utils/equipoDelEnlace.ts).
export const DIAS_SEMANA = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

/**
 * Los horarios de un día del horario propio. Cada día puede tener varios
 * ("de 9 a 11, de 2 a 4 y de 6 a 9", Lissette 2026-10-17): el hueco entre uno
 * y otro es el descanso de esa persona. Los guardados antes, con un solo
 * start/end, valen como un horario.
 */
export function franjasDelDia(dia) {
  if (!dia) return [];
  if (Array.isArray(dia.franjas)) return dia.franjas;
  return dia.start && dia.end ? [{ start: dia.start, end: dia.end }] : [];
}

/** El día del enlace como horarios: su descanso lo parte en dos. */
function franjasDelEnlace(x) {
  const start = x.start || "09:00", end = x.end || "17:00";
  if (x.breakStart && x.breakEnd && x.breakStart > start && x.breakEnd < end && x.breakStart < x.breakEnd) {
    return [{ start, end: x.breakStart }, { start: x.breakEnd, end }];
  }
  return [{ start, end }];
}

/** Le da a una persona su horario propio, empezando por una copia del enlace. */
export function conHorarioPropio(horarios, id, delEnlace) {
  const copia = {};
  for (const d of DIAS_SEMANA) {
    const x = (delEnlace && delEnlace[d]) || {};
    copia[d] = conFranjas({ active: !!x.active }, franjasDelEnlace(x));
  }
  return { ...(horarios || {}), [id]: copia };
}

/** El día con sus horarios, y start/end = el primero y el último (para lo viejo). */
function conFranjas(dia, franjas) {
  const orden = [...franjas].sort((a, b) => String(a.start).localeCompare(String(b.start)));
  return { ...dia, franjas: orden, start: orden[0]?.start || "", end: orden.length ? orden[orden.length - 1].end : "" };
}

/** Cambia la hora de un horario del día (i = cuál). */
export function cambiarFranja(horarios, id, dia, i, cambio) {
  const d = ((horarios || {})[id] || {})[dia] || { active: true };
  const fr = franjasDelDia(d).map((f, j) => (j === i ? { ...f, ...cambio } : f));
  return cambiarDiaPropio(horarios, id, dia, conFranjas(d, fr));
}

/** Agrega otro horario al día, después del último (una hora más tarde). */
export function agregarFranja(horarios, id, dia) {
  const d = ((horarios || {})[id] || {})[dia] || { active: true };
  const fr = franjasDelDia(d);
  const ultimo = fr.length ? fr[fr.length - 1].end : "09:00";
  const [h, m] = ultimo.split(":").map(Number);
  const mas = (n) => `${String(Math.min(23, h + n)).padStart(2, "0")}:${String(m || 0).padStart(2, "0")}`;
  return cambiarDiaPropio(horarios, id, dia, conFranjas({ ...d, active: true }, [...fr, { start: mas(1), end: mas(2) }]));
}

/** Quita un horario del día; sin ninguno, el día queda cerrado. */
export function quitarFranja(horarios, id, dia, i) {
  const d = ((horarios || {})[id] || {})[dia] || {};
  const fr = franjasDelDia(d).filter((_, j) => j !== i);
  return cambiarDiaPropio(horarios, id, dia, conFranjas({ ...d, active: fr.length > 0 && !!d.active }, fr));
}

/** Le quita el horario propio: vuelve a usar el del enlace. */
export function sinHorarioPropio(horarios, id) {
  const { [id]: _fuera, ...resto } = horarios || {};
  return resto;
}

/** Cambia un día del horario propio de una persona. */
export function cambiarDiaPropio(horarios, id, dia, cambio) {
  const h = (horarios || {})[id] || {};
  return { ...(horarios || {}), [id]: { ...h, [dia]: { ...(h[dia] || { active: false, start: "", end: "" }), ...cambio } } };
}
